import { LenderUsersWithScoringGroups } from 'ng2-app/models/pulse/scores.model';
import { ScoringGroup } from 'ng2-app/models/pulse/scoring-group.model';
import { Team } from 'app/models/dto/lender-user.model';

type CacheObject = {
  ttl: number;
  alwaysSync: boolean;
};

export type CacheConfig = {
  [K in keyof PulseStateModel['lastSync']]: CacheObject;
};

export type CacheKeys = keyof PulseStateModel['lastSync'];

export const CACHE_CONFIG: CacheConfig = {
  primaryScoringGroups: { ttl: 1000 * 60 * 5, alwaysSync: false },
  secondaryScoringGroups: { ttl: 1000 * 60 * 5, alwaysSync: true },
  teamsWithScoringGroups: { ttl: 1000 * 60 * 5, alwaysSync: false },
  lenderUsersWithScoringGroups: { ttl: 1000 * 60 * 5, alwaysSync: false },
} as const;

export interface PulseStateModel {
  primaryScoringGroups: ScoringGroup[];
  secondaryScoringGroups: ScoringGroup[];
  teamsWithScoringGroups: Team[];
  lenderUsersWithScoringGroups: LenderUsersWithScoringGroups;
  loading: boolean;
  fetching: boolean;
  lastSync: {
    primaryScoringGroups: Date | null;
    secondaryScoringGroups: Date | null;
    teamsWithScoringGroups: Date | null;
    lenderUsersWithScoringGroups: Date | null;
  };
}
